import { Collapse } from 'antd';
import WebsiteImageUploader from '../imageUploader/websiteImageUploader'
import WebsiteForm from '../forms/websiteForm'
import { useState } from 'react';
// import WebsiteForm2 from '../forms/websiteForm2'
// import { useSelector } from 'react-redux';
const { Panel } = Collapse;

const App = ({ edit }) => {
  // const { websiteDetails, websiteImage, theme
  // } = useSelector((state) => state.cardReducer);
  const [websiteDetails]=useState('')
  const [websiteImage]=useState([])
  const onChange = (key) => {
    console.log(key);
  };
  return (
    <Collapse defaultActiveKey={['0']} onChange={onChange}>
      <Panel header="Development Initiative" key="1">
        {/* {theme === "modern1" || theme === "standard1" ? */}
          <>
            <WebsiteImageUploader />
            {!(websiteImage[0]?.thumbUrl &&
              websiteImage[0]?.status !== "removed") && (websiteDetails?.websiteName || websiteDetails?.websiteUrl) ? (
              <p className="text-red-500">website Image is required</p>
            ) : (

              '')}

            <WebsiteForm />
          </>
          :
          {/* <WebsiteForm2 edit={edit} />
        } */}
      </Panel>

    </Collapse>
  );
};
export default App;